import registerRoutes from './routes';
import accountDetailsFactory from './services/details/accountDetails';
import changePasswordFactory from './services/changePassword/changePassword';

export default function (app) {
    app.factory('accountDetails', accountDetailsFactory);
    app.factory('changePassword', changePasswordFactory);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/account/index.js